export default class HistoryTimeline {
    constructor(options = {}) {
        this.blocks = options.blocks;

        if (!this.blocks || (this.blocks instanceof NodeList && this.blocks.length === 0)) {
            return;
        }
    }

    init() {
        const instances = Array.from(this.blocks instanceof NodeList ? this.blocks : [this.blocks]);

        instances.forEach((block) => {
            this.initBlock(block);
        });
    }

    initBlock(block) {
        const nav = block.querySelector(".history-nav");
        const buttons = block.querySelectorAll(".history-btn");
        const panels = block.querySelectorAll(".history-panel");

        if (!buttons.length || !panels.length) return;

        // Встановлюємо ширину пунктирної лінії для мобільного на всю довжину контенту
        const updateLineWidth = () => {
            if (nav) {
                nav.style.setProperty("--scroll-width", `${nav.scrollWidth}px`);
            }
        };

        updateLineWidth();
        window.addEventListener("resize", updateLineWidth);

        buttons.forEach((btn) => {
            btn.addEventListener("click", (e) => {
                const clickedBtn = e.currentTarget;
                const index = clickedBtn.getAttribute("data-index");

                // 1. Скидаємо активні класи
                buttons.forEach((b) => b.classList.remove("_active"));
                panels.forEach((p) => p.classList.remove("_active"));

                // 2. Додаємо активні класи
                clickedBtn.classList.add("_active");

                const targetPanel = block.querySelector(`.history-panel[data-panel="${index}"]`);
                if (targetPanel) {
                    targetPanel.classList.add("_active");
                }

                // 3. Плавно центруємо активний елемент на мобільних пристроях
                if (nav && window.innerWidth < 992) {
                    clickedBtn.scrollIntoView({
                        behavior: "smooth",
                        inline: "center",
                        block: "nearest",
                    });
                }
            });
        });
    }
}
